import Vue from 'vue'

const state = {
  apps: [],
  loading: false,
  lastUpdate: null,
  error: null
}

const getters = {
  getApps: (state) => state.apps,
  
  getAppByName: (state) => (appName) => {
    return state.apps.find(app => app.name === appName)
  },
  
  getBranchesByApp: (state) => (appName) => {
    const app = state.apps.find(app => app.name === appName)
    return app ? app.branches : []
  },
  
  getAllBranches: (state) => {
    const allBranches = []
    state.apps.forEach(app => {
      app.branches.forEach(branch => {
        allBranches.push({
          ...branch,
          appName: app.name,
          appId: app.id
        })
      })
    })
    return allBranches
  },
  
  isLoading: (state) => state.loading,
  
  getLastUpdate: (state) => state.lastUpdate,
  
  hasError: (state) => state.error !== null,
  
  getError: (state) => state.error
}

const mutations = {
  SET_APPS(state, apps) {
    state.apps = apps
  },
  
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  
  SET_LAST_UPDATE(state, timestamp) {
    state.lastUpdate = timestamp
  },
  
  SET_ERROR(state, error) {
    state.error = error
  },
  
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  /**
   * Busca todas as branches dos apps Amplify configurados
   */
  async fetchAmplifyBranches({ commit }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const api = new Vue.prototype.$httpClient()
      
      const response = await api.send('/amplify/branches', 'GET')
      
      // O $httpClient retorna a resposta em response.data
      const data = response.data || response
      
      if (data.statusCode === 200) {
        const apps = data.dados?.apps || []
        commit('SET_APPS', apps)
        commit('SET_LAST_UPDATE', new Date().toISOString())
        
        
        return {
          success: true,
          apps: apps
        }
      } else {
        throw new Error(data.mensagem || 'Erro ao buscar branches do Amplify')
      }
    } catch (error) {
      console.error('[AMPLIFY_BRANCHES] ❌ Erro ao buscar branches:', error)
      
      const errorMessage = error.mensagem || error.message || 'Erro ao buscar branches do Amplify'
      commit('SET_ERROR', errorMessage)
      
      return {
        success: false,
        error: errorMessage
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  /**
   * Recarrega as branches (útil para atualizar dados)
   */
  async refreshBranches({ dispatch }) {
    return await dispatch('fetchAmplifyBranches')
  },
  
  /**
   * Limpa os dados de branches
   */
  clearBranches({ commit }) {
    commit('SET_APPS', [])
    commit('SET_LAST_UPDATE', null)
    commit('CLEAR_ERROR')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

